<!-- 보관함 -->
<template>
  <div>
    <div class="setupBlock" v-if="this.emarticonMberPwdPolicy.certified">
      <dl class="setupPassword">
        <dt>비밀번호 관리</dt>
        <dd>
          <button type="button" class="setup" @click="$phoneCert">비밀번호 설정하기<span class="icon-chevron-right"></span></button>
        </dd>
      </dl>
      <dl class="setupPassword" v-if="this.$store.state.nativeStore.isApp">
        <dt>생체인증 관리</dt>
        <dd class="faceid">
          <p>
            <b>생체인증 설정하기</b>
            생체인증은 이마트 앱 설정에서 변경 가능합니다.
          </p>
          <button type="button" @click="handleBioSet"><img :src="fidoYn === 'Y' ? require('@/assets/images/ico-toggle-on.svg') : require('@/assets/images/ico-toggle.svg')" alt="생체인증 설정" /></button>
        </dd>
      </dl>
    </div>

    <form action="https://safe.ok-name.co.kr/MCommonSvl" ref="form" method="POST">
      <input type="hidden" name="tc" value="kcb.oknm.online.safehscert.popup.cmd.P931_CertChoiceCmd" />
      <input type="hidden" ref="cp_cd" name="cp_cd" value="" />
      <input type="hidden" ref="mdl_tkn" name="mdl_tkn" value="" />
      <input type="hidden" ref="target_id" name="target_id" value="" />
    </form>

    <alert-popup v-if="showAlertPopup" :message="alertMessage" @confirmPopupClickConfirm="showAlertPopup = false" />
    <password-confirm-popup v-if="showConfirmPopup === true" @confirmPopupClickNo="$confirmPopupClickNo" @confirmPopupClickYes="$confirmPopupClickConfirm" :message="alertMessage" :confirmPopupNoButton="confirmPopupNoButton" :confirmPopupYesButton="confirmPopupYesButton" />
  </div>
</template>

<script>
import certMixin from '@/plugins/certMixin';
import AlertPopup from '@/views/myemarticon/alertPopup.vue';
import apiList from '@/api/apiList';
import PasswordAlertPopup from '@/views/myemarticon/passwordAlertPopup.vue';
import PasswordConfirmPopup from '@/views/myemarticon/passwordConfirmPopup.vue';
import commonScripts from '@/plugins/commonScripts';

export default {
  name: 'setting',
  components: { PasswordConfirmPopup, PasswordAlertPopup, AlertPopup },
  mixins: [certMixin],
  data() {
    return {
      emarticonMberPwdPolicy: { certified: false },
      emarticonMberPwdRequest: {
        certifiedType: 'PASSWORD',
        emarticonPassword: '',
        prepaidCardNo: '',
      },
      // 본인인증
      popupStyle: 'height=640,width=430,toolbar=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no, modal=yes',
      certInfo: {
        crtfcSeCode: 'N', // 인증여부 구분 코드
        crtfcMthSeCode: '', // 01: 휴대폰, 02: 아이핀, 03: 신용카드
        ciNo: '',
        diNo: '',
        korMberNm: '',
        birthday: '',
        telNo: '',
        sexSeCode: '', // 01-남자,02-여자,03-기타
      },
      certInfoRes: null,
      rejectCert: '',
      showCertPhonePopup: false,

      showAlertPopup: false,
      alertMessage: '',
      showConfirmPopup: false,
      confirmPopupNoButton: '',
      confirmPopupYesButton: '',

      // visibilityEvent: false,
    };
  },
  computed: {
    fidoYn() {
      return this.$store.state.nativeStore.fidoYn;
    },
  },
  // watch: {
  //   fidoYn(value) {
  //     if(value === 'N' && this.$route.params.savePassword === 'Y') {
  //       this.alertMessage = '편리한 사용을 위하여<br> 생체인증을 설정 하겠습니까?';
  //       this.confirmPopupYesButton = '설정하기';
  //       this.confirmPopupNoButton = '닫기';
  //       this.showConfirmPopup = true;
  //     }
  //   },
  // },
  async mounted() {
    this.$heading('이마티콘 설정');
    await this.getAdminMberPwdPolicy();

    if (this.$route.params.error && this.$route.params.error !== '') {
      this.showAlertPopup = true;
      this.alertMessage = this.$route.params.error;
    }

    if (this.$store.state.nativeStore.isApp) {
      // Todo 안드로이드 뒤로가기 제어
      // if (this.$store.state.nativeStore.device === "and") {
      //   window.location.href = 'emart-today://goback/?enable=N'; // 뒤로가기 미허용
      // }

      await this.$store.dispatch('nativeStore/getFidoYn');

      if(this.fidoYn === 'N' && this.$route.params.savePassword === 'Y') {
        this.alertMessage = '편리한 사용을 위하여<br> 생체인증을 설정 하겠습니까?';
        this.confirmPopupYesButton = '설정하기';
        this.confirmPopupNoButton = '닫기';
        this.showConfirmPopup = true;
      }
    }
  },
  methods: {
    /**
     * 관리자 비밀번호 정책 조회
     */
    async getAdminMberPwdPolicy() {
      const adminRes = await apiList.getAdminMberPwdPolicy({ ctmmnyNo: this.$store.state.partnerId });
      this.emarticonMberPwdPolicy = adminRes.data.data;
      if(this.$store.state.nativeStore.isApp) {
        this.setIsEmarticonPasswordEnabled();
      }
    },
    /**
     * 기간별 이마티콘 비밀번호 사용여부 설정
     */
    setIsEmarticonPasswordEnabled() {
      const device = this.$store.state.nativeStore.device;
      const appVer = this.$store.state.nativeStore.appVer;
      const today = new Date();

      const firstBeginDate = new Date('2025-01-21T00:00:00');
      const secondBeginDate = new Date('2025-02-17T00:00:00');
      const thirdBeginDate = new Date('2025-04-01T00:00:00');

      let isNewVersion;
      if (device === 'and') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.1.2');
      } else if (device === 'ios') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.0.9');
      }

      if (today < firstBeginDate) {
      } else if (today >= firstBeginDate && today < secondBeginDate) {
        // 구버전: 비번/생체 사용 x
        // 신버전: 비번/생체 사용 가능
        if (!isNewVersion) {
          this.emarticonMberPwdPolicy.certified = false;
          this.$store.commit('setIsMberPwdAuthenticated');
        }
      } else if (today >= secondBeginDate && today <= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용 가능
        if (!isNewVersion) {
          this.alertMessage = '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.';
          this.confirmPopupYesButton = '업데이트';
          this.confirmPopupNoButton = '닫기';
          this.showConfirmPopup = true;
        }
      } else if (today >= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용
        if (!isNewVersion) {
          this.alertMessage = '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.';
          this.confirmPopupYesButton = '업데이트';
          this.confirmPopupNoButton = '닫기';
          this.showConfirmPopup = true;
        }
      }
    },
    /**
     * 이마티콘 앱 업데이트
     */
    $confirmPopupClickConfirm() {
      if (this.$route.params.savePassword === 'Y') {
        this.showConfirmPopup = false;
        this.handleBioSet();
      } else {
        const device = this.$store.state.nativeStore.device;
        if(device === 'and') { // 안드로이드일 경우
          let iframe = document.createElement('iframe');
          iframe.style.visibility = 'hidden';
          iframe.src = "market://details?id=com.emart.today";
          document.body.appendChild(iframe);
          document.body.removeChild(iframe);
        } else if (device === 'ios') { // 아이폰일 경우
          location.replace("http://itunes.apple.com/kr/app/id397728319?mt=8");
        }
      }
    },
    /**
     이마티콘 앱 업데이트 x
     */
    $confirmPopupClickNo() {
      this.$router.push({ name: 'home'});
    },
    /**
     * 휴대폰 본인인증 callback
     */
    async certCallback() {
      const certRes = this.$store.state.cert;
      if (certRes.result === 'success') {
        // tkn을 사용하여 인증 정보 조회
        const certInfo = await this.certResult(certRes);
        this.certInfoRes = certInfo.data;

        if (certInfo.result === 'success') {
          if (certInfo.mberInfoResult === 'success') {
            this.$router.push({ name: 'mberPassword', params: { certInfo: certInfo.data } });
          } else {
            this.showAlertPopup = true;
            this.alertMessage = '입력하신 인증 정보와 고객정보가 일치하지 않습니다.<br> 다시 확인해 주세요.';
          }
        } else if (certInfo.result === 'cancel') {
          // 본인인증 취소

          if (this.$store.state.nativeStore.isApp && this.$store.state.nativeStore.connect) {
            if (this.$store.state.nativeStore.device === 'and') {
              await this.$store.commit("nativeStore/connect", ['and']);
            } else if (this.$store.state.nativeStore.device === 'ios') {
              await this.$store.commit("nativeStore/connect", ['ios']);
            }

            await this.$store.dispatch('nativeStore/getFidoYn');

            // alert("router re : " + store.state.nativeStore.bridge);
          }

          // this.$router.go(0);
        } else {
          this.showAlertPopup = true;
          this.alertMessage = '인증 정보 조회 중 오류가 발생했습니다.';
        }
      } else {
        this.showAlertPopup = true;
        this.alertMessage = '간편 인증 오류가 발생했습니다.<br>다시 시도해 주세요.';
      }
    },
    /**
     * 휴대폰 본인인증
     */
    $phoneCert() {
      if (this.rejectCert !== '') {
        this.certCallback({ certResult: this.rejectCert });
        return;
      }

      this.$store.commit('certInit');

      if(this.$store.state.nativeStore.device === 'web') {
        const routeData = this.$router.resolve({
          name: 'phoneCert',
        });
        window.name = 'base';
        this.$store.state.certCallback = this.certCallback;
        window.store = this.$store;
        window.open(routeData.href, 'phoneCert', this.popupStyle);
      } else if(this.$store.state.nativeStore.device === 'and') {
        this.goCert();
      } else if(this.$store.state.nativeStore.device === 'ios') {
        const routeData = this.$router.resolve({
          name: 'phoneCert',
        });
        window.name = 'base';
        this.$store.state.certCallback = this.certCallback;
        window.store = this.$store;
        window.open(routeData.href, 'phoneCert', this.popupStyle);
      }
    },
    // /**
    //  * 휴대폰 본인인증
    //  */
    // $phoneCertOld() {
    //   if (this.rejectCert !== '') {
    //     this.certCallback({ certResult: this.rejectCert });
    //     return;
    //   }
    //
    //   this.$store.commit('certInit');
    //   const routeData = this.$router.resolve({
    //     name: 'phoneCert',
    //   });
    //   window.name = 'base';
    //   // 팝업 콜백 함수 전역 정의
    //   this.$store.state.certCallback = this.certCallback;
    //   this.$store.state.certFnType = 'OLD';
    //
    //   window.store = this.$store;
    //   window.open(routeData.href, 'phoneCert', this.popupStyle);
    // },
    getContextPath() {
      return location.href.substr(0, location.href.indexOf(location.host) + location.host.length);
    },
    async goCert() {
      const response = await apiList.getPhoneCert({ returnUrl: this.getContextPath() });
      const data = response.data.data;
      if (data.RSLT_CD === 'B000' || data.RSLT_CD === 'T300') {
        // Todo 안드로이드 뒤로가기 제어
        // if (this.$store.state.nativeStore.device === "and") {
        //   window.location.href = 'emart-today://goback/?enable=Y'; // 뒤로가기 허용
        // }

        setTimeout(() => {
          this.$refs.mdl_tkn.value = data.MDL_TKN;
          this.$refs.cp_cd.value = data.CP_CD;
          this.$refs.form.submit();
        }, 1000);
      } else {
        this.showAlertPopup = true;
        this.alertMessage = '인증 모듈 호출 오류 발생';
      }
    },
    /**
     * 이마티콘 생체인증 설정
     */
    async handleBioSet() {
      const res = await apiList.postCheckPasswordExist();
      if (res.data === 'N') {
        this.alertMessage = '생체인증은 비밀번호 설정 후 이용이 가능합니다.';
        this.showAlertPopup = true;
      } else {

        window.location.href = process.env.VUE_APP_EMART_BIO;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/setup.scss';
</style>
